<template>
  <f7-page
    ptr
    @ptr:refresh="refreshData"
    @page:reinit="getProjectList"
    infinite
    :infinite-distance="50"
    :infinite-preloader="showPreloader"
    @infinite="loadMore">
    <f7-navbar :no-shadow="true">
      <f7-nav-left
        color-theme="white"
        back-link="返回"
        back-link-url="/bid/list">
      </f7-nav-left>
      <f7-nav-title>找活</f7-nav-title>
    </f7-navbar>
    <div class="has-content">
      <div class="toolbar tabbar">
        <div class="toolbar-inner" style="padding: 0rem 0rem;">
          <a href="#bidProject1" class="tab-link tab-link-active" @click="switchTab(0)">
            <span style="font-size: 0.8rem;">任务招标信息</span>
          </a>
          <a href="#bidTeam1" class="tab-link" @click="switchTab(1)">
            <span style="font-size: 0.8rem;">人才招聘信息</span>
          </a>
          <a href="#bidWorker1" class="tab-link" @click="switchTab(2)">
            <span style="font-size: 0.8rem;">工友招募信息</span>
          </a>
          <span :class="`tab-link-highlight${tabIndex}`"></span>
        </div>
      </div>
    </div>
    <f7-tabs>
      <f7-tab id="bidProject1" tab-active>
        <div class="has-content" style="text-align: center;" v-if="projectList.length === 0">
          暂无任务招标信息
        </div>
        <div v-else>
          <div v-for="(item, index) in projectList" :key="item.id">
            <div class="has-content" style="padding-top: 0rem; padding-bottom: 0rem;">
              <bid-project :project="item"></bid-project>
            </div>
            <div class="divider-row" v-if="index !== projectList.length - 1"></div>
          </div>
        </div>
      </f7-tab>
      <f7-tab id="bidTeam1">
        <div class="has-content" style="text-align: center;">
          暂无人才招聘信息
        </div>
      </f7-tab>
      <f7-tab id="bidWorker1">
        <div class="has-content" style="text-align: center;">
          暂无工友招募信息
        </div>
      </f7-tab>
    </f7-tabs>
  </f7-page>
</template>
<script>
import { getBidList } from '@/api/bid';
import BidProject from '@/components/BidProject';

export default {
  components: {
    BidProject,
  },
  data() {
    return {
      tabIndex: 0,
      projectList: [],
      projectPageObj: { page: 1, pageSize: 10 },
      teamList: [],
      workerList: [],
      allowInfinite: true,
      showPreloader: true,
      projectAllowInfinite: true,
      projectShowPreloader: true,
      workerAllowInfinite: false,
      workerShowPreloader: false,
      friendAllowInfinite: false,
      friendShowPreloader: false,
    };
  },
  created() {
    this.getProjectList();
  },
  methods: {
    refreshData(event, done) {
      Promise.all([this.getProjectList()]).then(() => done());
    },
    switchTab(tabIndex) {
      this.tabIndex = tabIndex;
      if (this.tabIndex === 0) {
        this.allowInfinite = this.projectAllowInfinite;
        this.showPreloader = this.projectShowPreloader;
      } else if (this.tabIndex === 1) {
        this.allowInfinite = this.workerAllowInfinite;
        this.showPreloader = this.workerShowPreloader;
      } else if (this.tabIndex === 1) {
        this.allowInfinite = this.friendAllowInfinite;
        this.showPreloader = this.friendShowPreloader;
      }
    },
    getProjectList(pageParam) {
      this.projectPageObj = pageParam || { page: 1, pageSize: 10 };
      getBidList(this.projectPageObj).then((result) => {
        if (result.code === 0) {
          if (this.projectPageObj.page === 1) {
            this.projectList = (result.data || []).map(item => Object.assign(item, {
              pathDisplay: false,
            }));
          } else {
            (result.data || []).forEach((item) => {
              const pos = this.projectList.findIndex(w => w.id === item.id);
              if (pos < 0) {
                this.projectList.push(Object.assign(item, {
                  pathDisplay: false,
                }));
              } else {
                this.projectList.splice(pos, 1, item);
              }
            });
          }
          this.allowInfinite = true;
          this.projectAllowInfinite = true;
          if (this.projectList.length < 10 || (result.data || []).length === 0) {
            this.projectAllowInfinite = false;
            this.projectShowPreloader = false;
            this.showPreloader = false;
            this.allowInfinite = false;
          }
        }
      });
    },
    loadMore() {
      if (this.tabIndex === 0) {
        if (!this.projectAllowInfinite) {
          return;
        }
        this.projectAllowInfinite = false;
        if (this.teamList.length >= 100) {
          this.projectShowPreloader = false;
          return;
        }
        this.$set(this.projectPageObj, 'page', this.projectPageObj.page + 1);
        this.getProjectList(this.projectPageObj);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@/style/app-var.scss';

  .divider-row {
    font-size: 0.5rem;
    height: 0.5rem;
    width: 100%;
  }

  .tab-link-highlight0 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(0%, 0px, 0px);
  }

  .tab-link-highlight1 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(100%, 0px, 0px);
  }

  .tab-link-highlight2 {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 0.2rem;
    background: $theme-color;
    transition-duration: .3s;
    width: 33.333333%;
    transform: translate3d(200%, 0px, 0px);
  }

</style>



// WEBPACK FOOTER //
// src/pages/bid/projectList.vue